import { ref } from 'vue'

/**
 * @typedef {import('@tiptap/vue-2').Editor} Editor
 */

/**
 * Composable for managing slash commands in a Tiptap editor.
 * @param {import('vue').Ref<Editor>} editorInstance - Ref to the Tiptap editor instance.
 */
export function useTiptapSlashCommand(editorInstance) {
  const isSlashCommandActive = ref(false)
  const currentCommandRange = ref(null)
  const toggleSlashCommandActive = (active) => {
    isSlashCommandActive.value = active
  }

  // Update the replaceSlashCommand function to use the currentCommandRange
  const replaceSlashCommand = (content) => {
    if (!editorInstance.value || !currentCommandRange.value) return

    isSlashCommandActive.value = false

    editorInstance.value
      .chain()
      .focus()
      .deleteRange(currentCommandRange.value)
      .insertContent(content)
      .run()
  }

  return { isSlashCommandActive, currentCommandRange, toggleSlashCommandActive, replaceSlashCommand }
}
